import { useSyncExternalStore } from 'react'

const subscribe = () => () => {}
const getClientSnapshot = () => true
const getServerSnapshot = () => false

export default function useIsHydrated() {
	return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot)
}
